/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { BiLoaderAlt } from "react-icons/bi";
import { trackingMarketing } from "../../../../stores/actions/tracking.actions.types";

const renderMetadata = (metadata) => {
  if (!metadata || !Object.keys(metadata).length)
    return <span className='text-gray-400'>—</span>;
  const entries = Object.entries(metadata).filter(
    ([, val]) => val !== null && val !== undefined && val !== "",
  );
  if (!entries.length) return <span className='text-gray-400'>—</span>;

  return (
    <div className='flex flex-col gap-1'>
      {entries.map(([key, val]) => {
        const label = key;
        const display =
          typeof val === "object" ? JSON.stringify(val) : String(val);
        const isNumeric = !isNaN(Number(display)) && display.trim() !== "";

        return (
          <span
            key={key}
            className='inline-flex items-stretch rounded-md border border-gray-300 dark:border-white/10  overflow-hidden text-xs w-fit'
          >
            <span className='px-2 py-0.5 dark:bg-white/5 bg-gray-100 dark:text-gray-400 text-gray-800 font-normal border-r border-white/10 whitespace-nowrap'>
              {label} :
            </span>
            <span
              className={`px-2 py-0.5 dark:text-gray-100 text-gray-800 font-medium ${isNumeric ? "font-mono" : ""}`}
            >
              {display}
            </span>
          </span>
        );
      })}
    </div>
  );
};

const Marketing = (props) => {
  const [leads, setLeads] = useState([]);

  useEffect(() => {
    const params = { ...props.dateParams };
    if (props.source) params.source = props.source;
    props.trackingMarketing({
      data: params,
      callback: (data) => {
        if (data.success) setLeads(data.data.data);
      },
    });
  }, [props.dateParams, props.source]);

  if (props.loading) {
    return (
      <div className='flex dark:bg-boxdark bg-white items-center justify-center min-h-96'>
        <BiLoaderAlt className='animate-spin text-4xl text-primary dark:text-white' />
      </div>
    );
  }

  if (!leads?.length) {
    return (
      <div className='flex dark:bg-boxdark rounded bg-white items-center justify-center min-h-96'>
        <p className='text-xl text-center text-primary'>
          No Marketing Leads Found
        </p>
      </div>
    );
  }

  return (
    <div className='rounded-[10px] bg-white border border-stroke p-4 dark:bg-boxdark'>
      <div className='max-w-full overflow-x-auto'>
        <table className='w-full table-auto'>
          <thead>
            <tr className='bg-[#F7F9FC] dark:bg-black text-left'>
              <th className='min-w-[180px] px-4 py-2 font-medium text-sm'>
                Email
              </th>
              <th className='min-w-[140px] px-4 py-2 font-medium text-sm'>
                Phone
              </th>
              <th className='w-[500px] px-4 py-2 font-medium text-sm'>
                Viewed Products
              </th>
              <th className='min-w-[160px] px-4 py-2 font-medium text-sm'>
                Last Activity
              </th>
              <th className='min-w-[200px] px-4 py-2 font-medium text-sm'>
                Session ID
              </th>
            </tr>
          </thead>
          <tbody>
            {leads.map((item, index) => (
              <tr key={index} className='text-sm'>
                <td className='border-b px-4 py-2 dark:border-strokedark'>
                  {item.email}
                </td>
                <td className='border-b px-4 py-2 dark:border-strokedark'>
                  {item.phone || <span className='text-gray-400'>—</span>}
                </td>
                <td className='border-b px-4 py-2 dark:border-strokedark'>
                  <div className='grid grid-cols-2 gap-2 w-[480px]'>
                    {item.items.map((product, i) => (
                      <div
                        key={i}
                        className='rounded-lg border border-gray-200 dark:border-white/10 bg-gray-50 dark:bg-white/5 p-2.5 text-xs flex flex-col gap-1.5'
                      >
                        {(product.name || product.title) && (
                          <a
                            href={product.productUrl}
                            target='_blank'
                            rel='noreferrer'
                            className='font-semibold text-gray-800 dark:text-gray-100 leading-tight line-clamp-2 hover:text-red-500 hover:underline'
                          >
                            {product.name || product.title}
                          </a>
                        )}
                        <div className='flex items-center gap-2 mt-0.5 flex-wrap'>
                          {product.qty !== undefined && (
                            <span className='inline-flex items-center gap-1 rounded bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300 px-2 py-0.5 font-medium'>
                              Qty: {product.qty}
                            </span>
                          )}
                          {product.price !== undefined && (
                            <span className='inline-flex items-center gap-1 rounded bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-300 px-2 py-0.5 font-mono font-semibold'>
                              ${product.price}
                            </span>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </td>
                <td className='border-b px-4 py-2 dark:border-strokedark'>
                  {new Date(item.lastActivity).toLocaleString()}
                </td>
                <td className='border-b px-4 py-2 dark:border-strokedark font-mono text-xs truncate max-w-[200px]'>
                  {item.sessionId ?? item.session_id ?? (
                    <span className='text-gray-400'>—</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.app.visible,
});

export default connect(mapStateToProps, { trackingMarketing })(Marketing);
